import { useState } from "react";

import { motion } from "framer-motion";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Tag from "../components/Tag";

import "../styles/contact.scss";

function Contact(platform) {
    const [clickedEmail, setClickedEmail] = useState(false);
    const [clickedPhone, setClickedPhone] = useState(false);
    const email = "marc.lahaye.psychotherapist@gmail.com";
    const phone = "020 4538 2361";

    window.scrollTo(0, 0);

    const handleClick = (platform) => {
        if (platform === email) {
            if (!clickedEmail) navigator.clipboard.writeText(email);
            if (clickedPhone) setClickedPhone(prev => false);
            setClickedEmail(prev => !clickedEmail);
        } else if (platform === phone) {
            if (!clickedPhone) navigator.clipboard.writeText(phone);
            if (clickedEmail) setClickedEmail(prev => false);
            setClickedPhone(prev => !clickedPhone);
        }
    }

    return (
        <>
            <Header />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="min-height contact-height"
            >
                <div className="back-img contact-frame">
                    <div
                        className="contact link-section full-height"
                    >
                        <div className="contact-details">{email}</div>
                        <button
                            className={clickedEmail ? "email-copy" : ""}
                            onClick={() => handleClick(email)}
                        >
                            {clickedEmail ? "copied!" : "copy email"}
                        </button>
                        {/* <div className="contact-details">{phone}</div>
                        <button
                            className={clickedPhone ? "email-copy" : ""}
                            onClick={() => handleClick(phone)}
                        >
                            {clickedPhone ? "copied!" : "copy phone number"}
                        </button> */}
                    </div>
                </div>
            </motion.div>
            <Footer />
            <Tag />
        </>
    );
}

export default Contact;